module.exports = __webpack_public_path__ + "static/media/sugestije.f6fcdd09.png";